import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import "./styles/tokens.css";
import "./styles/shell.css";
import "./styles/knowledge.css";

const PublicPages = lazy(() => import("./features/payments/PublicPages"));
const publicPage = /^\/(pay\/|legal\/|club\/?$)/.test(window.location.pathname);

function render() {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>{publicPage ? <Suspense fallback={<p role="status">Загружаем…</p>}><PublicPages/></Suspense> : <App/>}</StrictMode>,
  );
}
// Public documents need no Telegram SDK. Payment forms load the official bank SDK on demand.
if (publicPage || window.Telegram) render();
else {
  const script = document.createElement("script");
  script.src = "https://telegram.org/js/telegram-web-app.js";
  script.onload = render; script.onerror = render;
  document.head.appendChild(script);
}
